/** @format */

import React, { Fragment, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Login } from "./components/login";
import { Register } from "./components/register";
import { Dashboard } from "./components/dashboard";
import { Request_submit } from "./components/request_submit";
import { Request_approve } from "./components/request_approve";
import { Admin } from "./components/admin";
import { ApprovedRequests } from "./components/approvedRequests";
import {ApprenticeshipReq} from "./components/apprenticeship_request";
import { Apprenticeship_req_treatment } from "./components/apprenticeship_requests_treatment";
import { Apprenticeship_req_asigned } from "./components/asigned_apprenticeship_requests";
import { ApprenticeshipReq_CFPA } from "./components/apprenticeship_CFPA";
import { ApprenticeshipReq_UNI } from "./components/apprenticeship_UNI";
import { ApprenticeshipReq_UNI_CENTER } from "./components/apprenticeship_UNI_CENTER";
import { VisitRequest } from "./components/visit-request";
import { VisistReqTreatment } from "./components/visit_request_treatment";
import { MyRequests } from "./components/myRequests";
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const setAuth = (Boolean) => {
    setIsAuthenticated(Boolean);
  };

  async function isAuth() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/is-verified`, {
        method: "GET",
        headers: { token: localStorage.token },
      });
      const parseRes = await response.json();

      parseRes === true ? setIsAuthenticated(true) : setIsAuthenticated(false);
    } catch (err) {
      console.error(err.message);
    }
  }

  useEffect(() => {
    isAuth();
  });

  useEffect(() => {
    if (!isAuthenticated) {
      <Login setAuth={setAuth}/>;
    }
  }, [isAuthenticated]);
  

  return (
    <Fragment>
      <div className='app'>
        <div className=''>
          <Router>
            <div>
              <Routes>
              <Route
                  exact
                  path='/'
                  element={
                    !isAuthenticated ? (
                      <Login setAuth={setAuth} />
                    ) : (
                      <Navigate to='/dashboard' />
                    )
                  }
                />
                <Route
                  exact
                  path='/login'
                  element={
                    !isAuthenticated ? (
                      <Login setAuth={setAuth} />
                    ) : (
                      <Navigate to='/dashboard' />
                    )
                  }
                />
                <Route
                  exact
                  path='/register'
                  element={
                    !isAuthenticated ? (
                      <Register setAuth={setAuth} />
                    ) : (
                      <Navigate to='/dashboard' />
                    )
                  }
                />
                <Route
                  exact
                  path='/dashboard'
                  element={
                    isAuthenticated ? (
                      <Dashboard setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                />
                <Route
                  exact
                  path='/request_submit'
                  element={
                    isAuthenticated ? (
                      <Request_submit setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                />
                <Route
                  exact
                  path='/request_approve'
                  element={
                    isAuthenticated ? (
                      <Request_approve setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                />
                <Route
                  exact
                  path='/approvedRequest'
                  element={
                    isAuthenticated ? (
                      <ApprovedRequests setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                  
                />
                <Route
                  exact
                  path='/ApprenticeshipReq'
                  element={
                    
                      <ApprenticeshipReq  />
                    
                  }
                  
                />

                <Route
                  exact
                  path='/ApprenticeshipReq_CFPA'
                  element={
                    
                      <ApprenticeshipReq_CFPA  />
                    
                  }
                  
                />

                <Route
                  exact
                  path='/ApprenticeshipReq_UNI'
                  element={
                      <ApprenticeshipReq_UNI  />

                  }
                  
                />

                <Route
                  exact
                  path='/ApprenticeshipReq_UNI_CENTER'
                  element={
                      <ApprenticeshipReq_UNI_CENTER  />
                  }
                  
                />

                <Route
                  exact
                  path='/Visit_request'
                  element={
                      <VisitRequest />
                  }
                  
                />

                <Route
                  exact
                  path='/Apprenticeship_req_treatment'
                  element={
                    isAuthenticated ? (
                      <Apprenticeship_req_treatment setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                  
                />

                <Route
                  exact
                  path='/Visit_request_treatment'
                  element={
                    isAuthenticated ? (
                      <VisistReqTreatment setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                  
                />

                <Route
                  exact
                  path='/MyRequests'
                  element={
                    isAuthenticated ? (
                      <MyRequests setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                  
                />

                <Route
                  exact
                  path='/admin/*'
                  element={
                    isAuthenticated ? (
                      <Admin setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                />
                <Route
                  exact
                  path='/apprenticeship_request_asigned'
                  element={
                    isAuthenticated ? (
                      <Apprenticeship_req_asigned setAuth={setAuth} />
                    ) : (
                      <Navigate to='/login' />
                    )
                  }
                />
              </Routes>
            </div>
          </Router>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}

export default App;
